import { useSelector } from 'react-redux';

import { currentOpenChatSelector } from '../../../selectors';
import { TPendingBlobFile } from '../../../types/file';
import { TImageFileAsDocument } from '../../../types/messageFiles';
import { TOpenedChat } from '../../../types/openedChats';

export const useImageAsDocument = (
  messageId: string,
  imageAsDocument?: TImageFileAsDocument,
): { imageAsDocumentDraft: TPendingBlobFile | null; imageAsDocument: TImageFileAsDocument | null } => {
  const currentChat = useSelector(currentOpenChatSelector);
  const { pendingFiles } = currentChat || ({} as TOpenedChat);

  const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];
  const imageAsDocumentBlobFiles = blobFiles.filter(({ type }) => type === 'imageAsDocument');

  if (imageAsDocument) {
    return { imageAsDocumentDraft: null, imageAsDocument };
  }

  if (imageAsDocumentBlobFiles.length) {
    return { imageAsDocumentDraft: imageAsDocumentBlobFiles[0], imageAsDocument: null };
  }

  return { imageAsDocumentDraft: null, imageAsDocument: null };
};
